// IMAGE_LAYOUT is referring to image being on the side and taking space
export const NUM_COLUMNS_WITHOUT_IMAGE_LAYOUT = 3;
export const NUM_COLUMNS_WITH_IMAGE_LAYOUT = 2;
